import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export class GameOverModel extends NotifyPropertyChanged {
    private static _instance: GameOverModel;
    static get instance(): GameOverModel {
        return this._instance ?? (this._instance = new GameOverModel());
    }
    private constructor() {
        super();
    }

    private _score: number = 0;
    get score(): number {
        return this._score;
    }
    setScore(value: number) {
        this._score = value;
        this.notifyPropertyChanged('score');
    }

    private _adForCoinsButtonVisible: boolean = false;
    get adForCoinsButtonVisible(): boolean {
        return this._adForCoinsButtonVisible;
    }
    setAdForCoinsButtonVisible(value: boolean) {
        this._adForCoinsButtonVisible = value;
        this.notifyPropertyChanged('adForCoinsButtonVisible');
    }

    //TK: In the original the formatting was done by the 'tally-end-totals', but I think the formatting
    // should be done at the latest possible moment, i.e. In the UI.
    private _coins: number = 20;
    get coins(): number {
        return this._coins;
    }
    setCoins(value: number) {
        this._coins = value;
        this.notifyPropertyChanged('coins');
    }

    //TK: Same as the coins. Formatting was done by the 'tally-end-totals', but should be done in the UI.
    private _totalCoins: number = 123456789;
    get totalCoins(): number {
        return this._totalCoins;
    }
    setTotalCoins(value: number) {
        this._totalCoins = value;
        this.notifyPropertyChanged('totalCoins');
    }

    private _highscoreText: string = '';
    get highscoreText(): string {
        return this._highscoreText;
    }
    setHighscoreText(value: string) {
        this._highscoreText = value;
        this.notifyPropertyChanged('highscoreText');
    }

    private _rank: string = 'RANK 4';
    get rank(): string {
        return this._rank;
    }
    setRank(value: string) {
        this._rank = value;
        this.notifyPropertyChanged('rank');
    }

    private _xpPercentage: number = 0.3;
    get xpPercentage(): number {
        return this._xpPercentage;
    }
    setXpPercentage(value: number) {
        this._xpPercentage = value;
        this.notifyPropertyChanged('xpPercentage');
    }
}
